import React, { useEffect, useState } from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { FormattedMessage } from "react-intl";
import Loader from "../Common/Loader/Loader";
import Link from "../Link/Link";
import LottieImage from "../Common/LottieImage/LottieImage";
import ProviderReviewCard from "../ProviderReviewCard/ProviderReviewCard";
import ReviewDoneBanner from "../ReviewDoneBanner/ReviewDoneBanner";
import messages from "../../locale/messages";
import animationData from '/public/lottie/paymentCompletedAnimationData.json';
import { useDispatch } from "react-redux";
import { updateReviewStatusAction } from "../../actions/reviews/updateReviewStatusAction";
import { AngleLeftArrowIcon } from "../Common/Assets/SVGIcon/CommonSvgIcon";
import bt from '../../components/commonStyle.css';
import s from './paymentCompleted.css';


const PaymentCompleted = ({ data, id }) => {
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()
    useEffect(() => {
        setLoad(true)
        async function fetchData() {
            await dispatch(updateReviewStatusAction({ bookingId: data?.id, isReviewPageVisited: 1 }))
        }
        fetchData()

    }, [])
    return (
        <>
            {!load && <Loader type="circle" show={true} />}
            {load && <>
                <div className={cx(bt.space3, s.topLinkContainer)}>
                    <Link to={'/dashboard'} className={cx(bt.customLink, 'customLinkRtl')}>
                        <AngleLeftArrowIcon />
                        <FormattedMessage {...messages.goBackText} />
                    </Link>
                </div>
                <div className={bt.commonViewBookingContainer}>
                    <div className={cx(bt.commonViewBookingLsBox)}>
                        <div className={cx(bt.commonViewBookingHeading, bt.space3)}>
                            <FormattedMessage {...messages.paymentCompleted} />
                        </div>
                        <div className={s.paymentCompletedImgContainer}>
                            <LottieImage animationData={animationData} containerClass="paymentCompletedLottieImg" />
                        </div>
                    </div>
                    <div className={cx(bt.commonStickyRsContainer)}>
                        <ProviderReviewCard data={data} />
                    </div>
                </div>
            </>
            }
            <ReviewDoneBanner data={data} />
        </>
    )
}

export default withStyles(bt, s)(PaymentCompleted);
